import React, { useState } from 'react';
import { Help } from "rbx";
import TextFieldMask from './TextFieldMask';
import { cpfOrCnpjValidate } from '../../../commons/validates';
import { unMask } from '../../../commons/masks';

const Mask = { CPF: '999.999.999-99999', CNPJ: '99.999.999/9999-99' };

const CpfCnpjField = (props) => {
  const { name, label, value, onChange, focus=false, ...other } = props;
  const [mask, setMask] = useState( unMask(value).length <= 11 ? Mask.CPF : Mask.CNPJ );
  const [cpfValid, setCpfValid] = useState([true]);

  const handleBlur = (e) => {
    const { value } = e.target;
    setCpfValid( value ? cpfOrCnpjValidate(value) : [] );
  }

  return (
    <>
      <TextFieldMask 
        label={label}
        name={name}
        mask={mask}
        value={value}
        onChange={e => {
          setMask( unMask(e.target.value).length <= 11 ? Mask.CPF : Mask.CNPJ );
          onChange(e);
        }}
        onBlur={handleBlur}
        focus={focus}
        {...other}
      />
      { !cpfValid[0] && <Help color="danger">{cpfValid[1]}</Help> }
    </>
  )

}

export default CpfCnpjField;
